const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CODE     = process.env.REACT_APP_API_HOST_KEY;

export const apiUrl = (endpoint) => `${BASE_URL}/${endpoint}?code=${CODE}`;